/**
 * Guide (Tutorial) System - Plugin Export
 *
 * Installation:
 *   import { TutorialPlugin } from '@core/tutorials'
 *   app.use(TutorialPlugin)
 *
 * Mark targets:
 *   <button v-tutorial="{ id: 'my-tutorial', text: 'הסבר', importance: 'info' }">
 *
 * Manual trigger:
 *   const { startTutorial, startTutorialGroup } = useTutorial()
 *   startTutorial('my-tutorial')
 *
 * The overlay is rendered once at app root (App.vue renders <TutorialOverlay />).
 */

import { vTutorial } from './vTutorial'
import { useTutorial, IMPORTANCE_LEVELS } from './useTutorial'

export { useTutorial, IMPORTANCE_LEVELS }
export { vTutorial }
export { isSeenByUser, markSeenByUser, clearAllForUser } from './tutorialStorage'
export { default as TutorialOverlay } from './components/TutorialOverlay.vue'

export const TutorialPlugin = {
  install(app) {
    app.directive('tutorial', vTutorial)
  },
}

export default TutorialPlugin
